
import './vendor/scroll-patrol.min.js';
import './vendor/smoothscroll.min.js';
import './vendor/ajax.min.js';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import Swipe from 'swipejs';

import { CookieConsentManager } from './CookieConsentManager.ts';

/* eslint-disable keyword-spacing, no-var, space-before-blocks */

( function() {
	// Article filters
	function handleArticleFilter( article_filter_toggle ) {
		return function(){
			document.body.classList.toggle( 'article-filter-open' );
		};
	}
	var article_filter_toggles = document.querySelectorAll( '.js-article-filter-toggle' );
	for( var i = 0; i < article_filter_toggles.length; i += 1 ) {
		article_filter_toggles[i].addEventListener( 'click', handleArticleFilter( article_filter_toggles[i] ) );
	}
} )();

( function() {
	// Swipe slideshow
	function getWindowWidth() {
		return window.innerWidth || document.documentElement.clientWidth;
	}
	if( window.innerWidth <= 767 ) {
		return;
	}
	new Swipe( document.getElementById( 'js-slider' ), {
		speed: 900,
		auto: 3000
	} );
} )();

( function() {
	// Social share
	function popUpWindow( url ) {
		var popup_width = 550;
		var popup_height = 420;
		var x = ( window.screen.width / 2 ) - ( popup_width / 2 );
		var y = ( window.screen.height / 2 ) - ( popup_height / 2 ) - 50;
		var new_window = window.open( url, '', 'dependent=1,height=' + popup_height.toString() + ',width=' + popup_width.toString() + ',left=' + x.toString() + ',top=' + y.toString() + ',resizable=0,status=0' );
		if( window.focus ){
			new_window.focus();
		}
		return false;
	}
	function handleSocialShare( share_button ) {
		var url = share_button.getAttribute( 'data-share-url' );
		return function( event ){
			if ( event.preventDefault ) {
				event.preventDefault();
			} else {
				event.returnValue = false;
			}
			popUpWindow( url );
		};
	}
	var social_share_buttons = document.querySelectorAll( '.social-share' );
	for ( var i = 0; i < social_share_buttons.length; i += 1 ) {
		social_share_buttons[i].addEventListener( 'click', handleSocialShare( social_share_buttons[i] ) );
	}
} )();

( function() {
	// Async external feeds
	function handleAjaxSuccess( feed_container ) {
		return function( data ){
			feed_container.classList.add( 'loaded' );
			feed_container.innerHTML = data;
			if ( typeof twttr !== 'undefined' ){
				twttr.widgets.load();
			}
		};
	}
	function handleAjaxError( feed_container ) {
		return function() {
			feed_container.classList.add( 'loaded' );
		};
	}
	var feed_containers = document.querySelectorAll( '.js-external-feed' );
	for ( var i = 0; i < feed_containers.length; i += 1 ) {
		var url = feed_containers[i].getAttribute( 'data-feed-url' );
		if ( !url ){
			continue;
		}
		ajax( {
			type: 'get',
			url: url,
			timeout: 8000,
			onSuccess: handleAjaxSuccess( feed_containers[i] ),
			onError: handleAjaxError( feed_containers[i] )
		} );
	}
} )();

( function() {
	// Sticky timeline
	function getOffsetTop( element ) {
		return element.offsetTop + ( element.offsetParent ? getOffsetTop( element.offsetParent ) : 0 );
	}
	function handleStickyTimeline( timeline ){
		var offset = -36; // this is set in CSS too - could query that but IE8 - quick-n-dirty magic number instead
		var start_point = timeline.offsetTop + offset;
		return function(){
			var scroll_y = ( window.pageYOffset !== undefined ) ? window.pageYOffset : ( document.documentElement || document.body.parentNode || document.body ).scrollTop;
			window.requestAnimationFrame( () => {
				timeline.style.top = Math.max( offset, ( scroll_y + offset ) - start_point ) + 'px';
			} );
		};
	}
	function handleSmoothscrollClick( scroll_to_id ) {
		return function( event ){
			if( event.preventDefault ) {
				event.preventDefault();
			} else{
				event.returnValue = false;
			}
			var scroll_to_element = document.getElementById( scroll_to_id );
			if( scroll_to_element ) {
				var y_position = getOffsetTop( scroll_to_element );
				smoothScroll.scroll( y_position, 1000, () => {
					document.location.hash = scroll_to_id;
				} );
			}
		};
	}
	function bindScrollPatrol( scroll_patrol, id, selectable ){
		scroll_patrol.add( {
			id: id,
			enter: function(){
				selectable.classList.add( 'loaded' );
			},
			leave: function(){
				selectable.classList.remove( 'selected' );
			}
		} );
	}
	var timeline = document.querySelector( '.timeline' );
	if( !timeline ){
		return;
	}
	var scroll_patrol = new ScrollPatrol( 40 );
	var year_anchors = timeline.querySelectorAll( 'a' );
	for( var i = 0; i < year_anchors.length; i += 1 ){
		var split_href = year_anchors[i].href.split( '#' );
		if( split_href.length !== 2 ){
			continue;
		}
		bindScrollPatrol( scroll_patrol, split_href[1], year_anchors[i].parentNode );
		year_anchors[i].addEventListener( 'click', handleSmoothscrollClick( split_href[1] ) );
	}
	// window.addEventListener( 'scroll', handleStickyTimeline( timeline ) );
} )();

( function() {
	//Initialize Masonry
	var elem = document.querySelector( '.masonry' );
	if( !elem ){
		return;
	}
	var img_load = imagesLoaded( elem );
	var masonry = new Masonry( elem, {
		itemSelector: '.masonry__item',
		transitionDuration: 0,
		initLayout: false
	} );
	img_load.on( 'progress', () => {
		masonry.layout();
	} );
} )();

( () => {
	const cookie_categories_meta = document.querySelector(
		'meta[name="ten4_cookie_consent_categories"]'
	);
	const cookie_providers_meta = document.querySelector(
		'meta[name="ten4_cookie_consent_providers"]'
	);
	const cookie_provider_hash_meta = document.querySelector(
		'meta[name="ten4_cookie_consent_provider_hash"]'
	);
	new CookieConsentManager(
		JSON.parse( cookie_categories_meta.content ),
		JSON.parse( cookie_providers_meta.content ),
		cookie_provider_hash_meta.content,
		true
	);
} )();
